import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModuleProgressQuizPageRoutingModule } from './module-progress-quiz-routing.module';

import { ModuleProgressQuizPage } from './module-progress-quiz.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleProgressQuizPageRoutingModule
  ],
  declarations: [ModuleProgressQuizPage]
})
export class ModuleProgressQuizPageModule {}
